import httpServices from './httpServices';
import { Url } from './http';

const apiUrl = Url.baseUrl;

const loginUserKey = '';
const tokenKey = 'token';
const tokenExpire = 'token_expire';

export function getBearerToken() {
    return localStorage.getItem(tokenKey);
}

export function isTokenValid() {
    const token = localStorage.getItem(tokenKey);
    if (!token) {
        return false;
    }

    const expire = localStorage.getItem(tokenExpire);
    // If we only have a token (no expiry row), do not treat the session as dead — full reloads
    // (e.g. payment gateway return) would otherwise clear the token and look like a logout.
    if (!expire) {
        return true;
    }

    const expiresAt = new Date(expire);
    if (Number.isNaN(expiresAt.getTime())) {
        return true;
    }

    return new Date() < expiresAt;
}

export async function login(username, password) {
    const data = { email: username, password };

    // Call backend login
    const { data: token } = await httpServices.post(apiUrl + '/CustLogin', data);
    // Save token + expiry
    localStorage.setItem(loginUserKey, data);
    localStorage.setItem(tokenKey, token.token);
    localStorage.setItem(tokenExpire, token['.expires']);

    // Set token in interceptor
    httpServices.setAccessToken(getBearerToken());
}

export function logout() {
    localStorage.removeItem(tokenKey);
    localStorage.removeItem(tokenExpire);
    httpServices.setAccessToken(null);
}

export function isAuthenticated() {
    return isTokenValid();
}

// AUTO LOGIN (token still valid after page refresh)
if (isTokenValid()) {
    httpServices.setAccessToken(getBearerToken());
    console.log("✔ Auto Login: Token active");
} else {
    console.log("ℹ Guest browsing, no active token");
}

export default {
    login,
    logout,
    getBearerToken,
    isAuthenticated
};
